"use client";

import { toast } from "sonner";
import { cn } from "@/lib/utils";

export default function InlineCodeMark({ children }: any) {
  function copyCode() {
    navigator.clipboard.writeText(children);
    toast.success("Copied to clipboard");
  }

  return (
    <code
      className={cn("group inline-code", {
        "whitespace-nowrap": typeof children === "string" && !children.includes(" "),
      })}
    >
      <span>{children}</span>
      {/* The visible "Copy" label is CSS-generated content. Real text here
          would sit inside the <code> element's text layer, so every crawler,
          text extractor and screen reader would read "datasetCopy". The
          accessible name comes from aria-label instead. */}
      <button
        type="button"
        aria-label="Copy"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          copyCode();
        }}
        className="inline-code-copy"
      />
    </code>
  );
}
